import { battlestationSchema } from "@/Schemas/battlestationSchema";
import { z } from "zod";

export const BattlestationFormSchema = battlestationSchema;

export type BattlestationForm = z.infer<typeof BattlestationFormSchema>;
